import { render, staticRenderFns } from "./PartialSumPopup.vue?vue&type=template&id=0d84e972&"
import script from "./PartialSumPopup.vue?vue&type=script&lang=js&"
export * from "./PartialSumPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports